export default "__VITE_ASSET__2Ru9vqH4__"